export const HOME_PATH = 'HOME_PATH';
export const SCHOOL_INFO = 'SCHOOL_INFO';
export const QUESTIONNAIRE = 'QUESTIONNAIRE';
export const CONTACT_DATA = 'CONTACT_DATA';
export const REQUESTS = 'REQUESTS';
export const MOVE_IN = 'MOVE_IN';
export const CLICKED_COMPANIES = 'CLICKED_COMPANIES';
export const SEARCH_TYPE = 'SEARCH_TYPE';
export const SCREEN_NAME = 'SCREEN_NAME';
export const WIDGET_PROPS = 'WIDGET_PROPS';
export const WIDGET_SCHOOL_LOADING = 'WIDGET_SCHOOL_LOADING';

// User
export const USER_LOGGED = 'USER_LOGGED';
// end User

// Posting
export const POSTING_PERSISTENT_STATE = 'POSTING_PERSISTENT_STATE';
export const PROPERTY_TYPE = 'PROPERTY_TYPE';
export const PROPERTY_LOCATION = 'PROPERTY_LOCATION';
export const PROPERTY_CONTACT_INFORMATION = 'PROPERTY_CONTACT_INFORMATION';
export const PROPERTY_ACCOUNT = 'PROPERTY_ACCOUNT';
export const PROPERTY_NAME = 'PROPERTY_NAME';
export const PROPERTY_DESCRIPTION = 'PROPERTY_DESCRIPTION';
export const PROPERTY_FLOORPLANS = 'PROPERTY_FLOORPLANS';
export const PROPERTY_AMENITIES = 'PROPERTY_AMENITIES';
export const PROPERTY_IMAGES = 'PROPERTY_IMAGES';
export const PAYMENT_INFO = 'PAYMENT_INFO';
// end Posting

// Dialogs
export const DIALOGS = 'DIALOGS';
// end Dialogs
